import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin } from '../utils/auth';
import './AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await loginAdmin(formData.email, formData.password);
      navigate('/admin');
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message || 'Ошибка входа');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__container">
        <div className="admin-login__header">
          <img src="/assets/img/logo.svg" alt="Pro Investor" className="admin-login__logo" />
          <h1 className="admin-login__title">Админ-панель</h1>
          <p className="admin-login__subtitle">Войдите в систему управления</p>
        </div>

        <form className="admin-login__form" onSubmit={handleSubmit}>
          {error && (
            <div className="admin-login__error">
              {error}
            </div>
          )}

          <div className="admin-login__field">
            <label htmlFor="email" className="admin-login__label">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="admin-login__input"
              placeholder="Введите email"
              required
              disabled={isLoading}
            />
          </div>

          <div className="admin-login__field">
            <label htmlFor="password" className="admin-login__label">
              Пароль
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="admin-login__input"
              placeholder="Введите пароль"
              required
              disabled={isLoading}
            />
          </div>

          <button
            type="submit"
            className="admin-login__button"
            disabled={isLoading}
          >
            {isLoading ? 'Вход...' : 'Войти'}
          </button>
        </form>

        <div className="admin-login__footer">
          <button 
            className="admin-login__back"
            onClick={() => navigate('/')}
          >
            ← Вернуться на главную
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;